<template>
  <vs-prompt
    title="Add list"
    @cancel="val = ''"
    @accept="onAccept"
    :active.sync="addNewCategoryPrompt"
    accept-text="Add"
    :is-valid="validForm"
  >
    <div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input
            v-on:keypress="isValid($event)"
            class="inputx w-full"
            placeholder="Title"
            v-model="category_title"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Color</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <ul class="color-select">
            <li
              v-for="color in selectableColors"
              :key="color"
              @click="category_color = color"
            >
              <div :class="{ selected: category_color == color }"></div>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Icon</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <ul class="color-select">
            <li
              v-for="icon in selectableIcons"
              :key="icon"
              class="mr-5"
              @click="category_icon = icon"
            >
              <div
                class="flex items-center"
                :class="{ selectedIcon: category_icon == icon }"
              >
                <feather-icon
                  :icon="parseIcon(icon)"
                  :style="{ 'background-color': category_color }"
                  class="p-3 rounded-full text-white"
                  svgClasses="h-5 w-5"
                ></feather-icon>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  //props: ["categories"],
  data() {
    return {
      addNewCategoryPrompt: false,

      category_icon: "archive",
      category_color: "#cea8bc",
      category_title: "",

      category_id: "",

      selectableIcons: [
        "archive",
        "inbox",
        "zap",
        "info",
        "list",
        "user",
        "users",
      ],
      selectableColors: [
        "#cea8bc",
        "#a9c3c8",
        "#bcd611",
        "#de9c9b",
        "#fbe6a2",
        "#aac1f0",
        "#b2a7d2",
        "#bc4b31",
        "#111111",
      ],
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      preferredRole: "users/preferredRole",
      categories: "personalTodos/categories",
    }),
    validForm() {
      return (
        this.category_title !== "" &&
        !_.some(this.categories, (e) => e.name === this.category_title)
      );
    },

    selectableVenues() {
      return _.chain(this.venues)
        .map((e) => {
          return { ...e, text: e.name, value: e.venueId };
        })
        .groupBy((e) => e.country)
        .map((v, k) => {
          //console.log("Name: ", k, "value", v)
          return { title: k, group: v };
        })
        .value();
    },
  },
  methods: {
    parseIcon(icon) {
      if (icon.includes("Icon")) return icon;
      else return icon.charAt(0).toUpperCase() + icon.slice(1) + "Icon";
    },
    isValid(e) {
      if (this.category_title.length < 15) return true;
      else e.preventDefault();
    },
    show() {
      this.addNewCategoryPrompt = true;
    },
    async onAccept() {
      this.$vs.loading();
      const data = {
        name: this.category_title,
        icon: this.category_icon,
        color: this.category_color,
      };
      await this.$store.dispatch("personalTodos/createCategory", data);
      this.$vs.notify({
        color: "success",
        title: "category added",
        text: "Your category was added",
      });
      this.$vs.loading.close();
    },
    closeAddNewCategoryPrompt() {},
  },
};
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.vs-dialog {
  .after {
    background: rgba(0, 0, 0, 0) !important;
  }
  position: relative;
}

.button-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.color-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    $colors: (
      #cea8bc,
      #a9c3c8,
      #bcd611,
      #de9c9b,
      #fbe6a2,
      #aac1f0,
      #b2a7d2,
      #bc4b31,
      #111111
    );
    @for $i from 1 through length($colors) {
      &:nth-child(#{$i}) {
        background-color: nth($colors, $i);
        box-shadow: 0px 8px 12px -6px lighten(nth($colors, $i), 0.9);
      }
    }

    .selectedIcon {
      border-radius: 50%;
      border: 3px solid #333;
    }

    .selected {
      position: absolute;
      display: block;
      border-radius: 50%;
      border: 3px solid #333;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
